<template>
  <b-modal
    id="grading-modal"
    ref="gradingModal"
    title="Essay Manual Grading"
    size="lg"
    hide-footer
  >
    <pre>{{ selectedItem }}</pre>
    <b-card
      v-for="(item, index) in selectedItem"
      :key="index"
      class="exam-card-item transition"
      no-body
      style="
        padding: 15px;
        border-radius: 10px;
        transition: transform 0.3s, box-shadow 0.3s;
      "
      @mouseover="hover = true"
      @mouseleave="hover = false"
      :style="{
        transform: hover ? 'scale(1.02)' : 'scale(1)',
        boxShadow: hover
          ? '0 4px 20px rgba(0, 0, 0, 0.1)'
          : '0 2px 8px rgba(0, 0, 0, 0.05)',
      }"
    >
      <b-row align-h="between" class="mb-3">
        <b-col>
          <h5 class="text-primary mb-0">
            {{ formattedApplicantFullName[index] }}
          </h5>
          <p class="text-muted small">
            {{ item.applicant_info.email || "No email available" }}
          </p>
          <b-col v-for="question in item.essay_questions" :key="question.id">
            <span class="font-weight-semibold mb-0">
              {{ question.question_text || "No description available" }}
            </span>
            <p class="text-muted small mb-0">
              {{ question.response || "Applicant Answer is not Available" }}
            </p>
          </b-col>
        </b-col>
        <b-col cols="auto" class="text-right">
          <b-badge variant="primary" class="font-weight-bold px-3 py-2">
            Applicant Score: {{ item.score || 0 }}
          </b-badge>
        </b-col>
        <b-col cols="auto" class="text-right">
          <b-badge
            v-for="essay_point in item.essay_questions"
            :key="essay_point.question_id"
            variant="info"
            class="font-weight-bold px-3 py-2"
          >
            Question Points: {{ essay_point.points || 0 }}
          </b-badge>
        </b-col>
      </b-row>

      <div class="d-flex align-items-center mb-3">
        <b-form-input
          placeholder="Enter your score for this applicant answer"
          class="mr-2"
          v-model="manualScores[index]"
        ></b-form-input>
        <b-button variant="primary" @click="handleUpdateScore(index, item)"
          >Submit</b-button
        >
      </div>
    </b-card>
  </b-modal>
</template>

<script>
export default {
  props: {
    examId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hover: false,
      selectedItem: [],
      manualScores: [],
    };
  },
  computed: {
    formattedApplicantFullName() {
      return this.selectedItem.map((item) => {
        const firstName = item.applicant_info.first_name || "No Applicant Name";
        const lastName = item.applicant_info.last_name || "No Applicant Name";
        return `${firstName} ${lastName}`;
      });
    },
  },
  methods: {
    fetchEssayGradingDetails() {
      this.$store.dispatch("exam/getExamsWithManualGrading").then((res) => {
        const exams = res.data.data;
        const currentExamId = String(this.examId).trim();

        console.log("Filtering exams for examId:", currentExamId);

        if (Array.isArray(exams)) {
          this.selectedItem = exams.filter(
            (item) => String(item.exam_id).trim() === currentExamId
          );

          if (this.selectedItem.length === 0) {
            console.warn("No submissions found for examId:", currentExamId);
          }
        } else {
          console.error("Expected an array but got:", exams);
          this.selectedItem = [];
        }
      });
    },
    handleUpdateScore(index, item) {
      this.$store
        .dispatch("exam/updateApplicantScores", {
          examId: item.exam_id,
          applicantId: item.applicant_info.applicant_id,
          score: this.manualScores[index],
        })
        .then((res) => {
          if (res.status === 200) {
            this.$bvToast.toast("Score updated successfully!", {
              title: "Success",
              variant: "success",
              solid: true,
            });
          } else {
            this.$bvToast.toast("Failed to update score.", {
              title: "Error",
              variant: "danger",
              solid: true,
            });
          }
        })
        .catch((error) => {
          console.error("Error updating score:", error);
          this.$bvToast.toast("An error occurred.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        });
    },
  },
  mounted() {
    this.fetchEssayGradingDetails();
  },
  watch: {
    examId(newVal) {
      if (newVal) {
        this.fetchEssayGradingDetails();
      }
    },
  },
};
</script>
